import React from 'react';
import Img from "react-cool-img";
import { useTranslation } from 'react-i18next';

import { Col, Row } from 'antd/lib/grid';

import { OpenLibrary } from '@assets/images';

import { WFDefaultButton, WFDivider } from '@components/index';
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import Navigator from '@navigator/index';
import { NavigationUrl, URLs } from '@navigator/NavigationUrl';

import './styles.less';

const OpenLibrarySection = () => {
    const { t } = useTranslation();

    const navigateTOLib = () => {
        Navigator.push(NavigationUrl.generate(URLs.library));
    };

    const renderListItems = (texts: string[]) => (
        texts.map((text) => (
            <li><Text
                className="open-lib-text-description"
                textType={TextType.h8}
                fontFamilyVariant={FontFamilyVariant.regular}
                text={text}
            /></li>
        ))
    );

    const listItemText = [
        t('guestView.labelsAndTitles.OPEN_LIBRARY_CONTENT1'),
        t('guestView.labelsAndTitles.CASE_STUDY'),
        t('guestView.labelsAndTitles.MASTER_CLASSES')
    ];

    return (
        <section>
            <Row className="open-lib-section">
                <Col sm={24} md={12}>
                    <Img alt="Open library tablet picture" src={OpenLibrary} className="open-lib-img" />
                </Col>
                <Col sm={24} md={10} className="open-lib-description">
                    <Text
                        className="open-lib-text"
                        fontFamilyVariant={FontFamilyVariant.bold}
                        text={t('guestView.labelsAndTitles.OPEN_LIBRARY')}
                        textType={TextType.display2}
                    />
                    <Text
                        className="open-lib-text-description"
                        textType={TextType.h8}
                        fontFamilyVariant={FontFamilyVariant.regular}
                        text={t('guestView.labelsAndTitles.OPEN_LIBRARY_SUB')}
                    />
                    <div className='lib-list'>
                        <ul>
                            {renderListItems(listItemText)}
                        </ul>
                    </div>
                    <div className="access-open-lib">
                        <WFDefaultButton className="access-open-lib-btn wf_default_button" htmlType={'button'} onClick={navigateTOLib}>{t('guestView.labelsAndTitles.ACCESS_LIBRARY')}</WFDefaultButton>
                    </div>
                </Col>
            </Row>
            <WFDivider style={{ margin: '0px' }} />
        </section>
    )
};

export default OpenLibrarySection;
